import { Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  FpxModal
} from "@fpx/core";
import { Observable, map, of } from "rxjs";
import { Router } from "@angular/router";
import { MailboxfilterService } from "../mailboxfilter-service/mailboxfilter.service";
import { Mailboxfilter } from "../mailboxfilter-service/mailboxfilter.model";

export class mailboxFilterState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
}


@Injectable()
export class mailboxFilterHelper extends BaseFpxFormHelper<mailboxFilterState>{

   constructor( private mailboxFilterService: MailboxfilterService,private _httpProvider : HttpProviderService,private _router: Router) 
    {
        super(new mailboxFilterState());
    }
   
  override doPreInit(): void {;

 }
   

  public override doPostInit(): void {
  
  }
  
 
  public override preSubmitInterceptor(payload: Mailboxfilter):any {
     // WRITE CODE HERE TO HANDLE 
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n
}
